import { createSelector, createFeatureSelector } from '@ngrx/store';
import { UserState } from './user-details.reducer';


export const selectUserState = createFeatureSelector<UserState>('user');

export const selectUser = createSelector(
  selectUserState,
  (state: UserState) => state.user
);

export const selectLoading = createSelector(
  selectUserState,
  (state: UserState) => state.loading
);